import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./CorporatePageElementsCss/CorporatePaymentSuccess.css";
import { updateCorporatePaymentStatus, updatePaymentStatus, userLogin } from "../../api/api";
import { setUserData } from "../../utils/auth";


const CorporatePaymentSuccess = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [paymentData, setPaymentData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [apiCalled, setApiCalled] = useState(false);

  const handleUpdatePayment = async (data) => {
    if (apiCalled) return; // prevent multiple calls
    setLoading(true);
    setError(null);
    try {
      const payment_userId = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")).user_id : '';
      const center_id = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")).centerid : '';
      const date = new Date(data.TXNDATE);
      const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`;
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        Transaction_id: data.TXNID,
        Bill_id: '',
        Amount: data.TXNAMOUNT,
        Payment_Type: "C",
        
        
        CenterID: center_id,
        Appoinment_id: '',
        user_id: payment_userId,
        Transaction_date: formattedDate,
        Transaction_status:"Success",
      };

      const response = await updateCorporatePaymentStatus(payload);
      console.log(response);
      if (response.status === 200) {
        localStorage.removeItem("payment_user_id");
        setApiCalled(true);
        // Refresh user data
        const raw = localStorage.getItem("rb_corp_creds");
        const parsed = raw ? JSON.parse(raw) : {};
        const mobileNo = parsed?.mobile_no || "";
        const password = parsed?.password || "";
        if (mobileNo && password) {
          try {
            const loginPayload = {
              RBAuthKey: "RBDWAh!Q1s74e",
              LoginType: "CC",
              mobile_no: mobileNo,
              password: password,
              deviceid: "",
            };
            const loginResponse = await userLogin(loginPayload);
            if (loginResponse?.data?.status === "success") {
              setUserData(loginResponse.data);
            }
          } catch (loginError) {
            console.error("Error refreshing user data:", loginError);
          }
        }
      } else {
        setError("Payment update failed");
      }
    } catch (error) {
      console.error("Error updating payment status:", error);
      setError("Error updating payment status: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    try {
      // Decode Base64
      const decoded = atob(token);
      const parsedData = JSON.parse(decoded);
      console.log("Decoded Payment Data:", parsedData);

      // Validate success
      if (parsedData?.STATUS === "TXN_SUCCESS") {
        setPaymentData(parsedData);
        if(parsedData?.transactionType === "corporatePayment"){
        handleUpdatePayment(parsedData);
        }
      } else {
        navigate("/corporate");
      }
    } catch (err) {
      console.error("Invalid payment data", err);
      navigate("/corporate");
    }
  }, [token, navigate]);

  //  const handleCorporateLogin = async () => {
  //     // e.preventDefault();
  
  //     try {
  //       const payload = {
  //         RBAuthKey: "RBDWAh!Q1s74e",
  //         LoginType: "CC",
  //         mobile_no: storedUser?.mobile_no || "",
  //         password: storedUser?.password || "",
  //         deviceid: "",
  //       };
  
  //       const response = await userLogin(payload);
  //       console.log("Login response:", response);
  
  //       if (response?.data?.status === "success") {
  //         // ✅ Store user data using centralized helper
  //         setUserData(response.data);
  
  //         // Persist corporate credentials to localStorage
  //         try {
  //           localStorage.setItem(
  //             "rb_corp_creds",
  //             JSON.stringify({
  //               mobile_no: storedUser?.mobile_no || "",
  //               password: storedUser?.password || "",
  //             })
  //           );
  //         } catch (err) {
  //           console.warn("Could not save corporate credentials:", err);
  //         }
  
  //         console.log("Login successful:", response.data);
  
  //         // ✅ Redirect to dashboard
  //         // navigate("/corporate");
  //       } else {
  //         alert(response?.data?.message || "Invalid mobile number or password.");
  //       }
  //     } catch (error) {
  //       console.error("Error during login:", error);
  //       alert("Something went wrong. Please try again.");
  //     }
  //   };

  if (loading) return <div className="cps-wrapper"><div className="cps-card">Processing payment update...</div></div>;
  if (error) return <div className="cps-wrapper"><div className="cps-card"><div className="cps-icon">✗</div><h2>Payment Update Failed</h2><p>{error}</p><button onClick={() => navigate("/corporate")}>Go to Dashboard</button></div></div>;
  if (!paymentData) return null;

  return (
    <div className="cps-wrapper">
      <div className="cps-card">
        <div className="cps-icon">✔</div>

        <h2>Payment Successful</h2>

        <p>Thank you for your payment.</p>

        <div style={{ marginTop: 20, textAlign: "left" }}>
          <p><b>Order ID:</b> {paymentData.ORDERID}</p>
          <p><b>Transaction ID:</b> {paymentData.TXNID}</p>
          <p><b>Amount:</b> ₹{paymentData.TXNAMOUNT}</p>
          <p><b>Payment Mode:</b> {paymentData.PAYMENTMODE}</p>
          <p><b>Date:</b> {paymentData.TXNDATE}</p>
        </div>

        <button
          style={{ marginTop: 30 }}
          onClick={ () => {
            
            navigate("/corporate");
            // await handleCorporateLogin();
          }}
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default CorporatePaymentSuccess;
